import headerUser from "@/components/mixins/headerUser";
import utils from "../../utils";

export default {
  data() {
    return {
      user: {},
      locked: null,
    };
  },
  created() {
    this.setupUser();
  },
  methods: {
    ...headerUser.methods,
    openModal(resource) {
      this.locked = resource;
    },
    closeModal() {
      this.locked = null;
    },
    goToLogin() {
      utils.redirectToLogin(null, this.config, `${document.location.href}`, null);
    },
  },
};
